/**
 * PostHog connection constants shared by backend and frontend. The project token is
 * a public write-only value (it can capture events, never read data), so it is
 * committed rather than injected at build time. Empty token disables analytics.
 */
export const POSTHOG_CONFIG = {
   token: 'phc_vTZBGp22ZL4P5z6BBP25hfQyB9qqZD7THkMcfvjVNayb',

   /** Ingestion host the browser SDKs talk to: our managed reverse proxy. */
   host: 'https://internal.amazingboards.com',

   /** The real PostHog app, needed alongside a proxied host for toolbar and app links. */
   uiHost: 'https://us.posthog.com',

   /** Direct ingestion host for server-to-server traffic (posthog-node, OTLP logs). */
   serverHost: 'https://us.i.posthog.com',

   /** OTLP endpoint backend logs ship to. */
   otlpLogsUrl: 'https://us.i.posthog.com/i/v1/logs',

   /** OTLP endpoint backend traces ship to. Beta; PostHog may change the path. */
   otlpTracesUrl: 'https://us.i.posthog.com/i/v1/traces',
};
